import React from 'react';
import { useOutletContext } from 'react-router-dom';
import Insights from '../../components/Insights';

export default function InsightsPage() {
  const ctx = useOutletContext();
  return <Insights {...ctx} />;
}
